import { Link } from 'react-router-dom';

// React Router's <Link> treats an absolute URL as a relative route path, so
// external links need a plain <a> instead.
const isExternalUrl = url => typeof url === 'string' && /^https?:\/\//i.test(url);

const MiscEngage = ({
  title,
  description,
  image,
  more
}) => {
  const moreUrl = more.url;
  const moreTitle = more.title;
  return <div className="card">
      <div className="card-body px-10 py-7.5 lg:pr-12.5">
        <div className="flex flex-wrap md:flex-nowrap items-center gap-6 md:gap-10">
          <div className="flex flex-col items-start gap-3">
            <h2 className="text-1.5xl font-medium text-gray-900">{title}</h2>

            <p className="text-sm text-gray-800 leading-5.5 mb-2.5">{description}</p>
          </div>

          {image}
        </div>
      </div>

      <div className="card-footer justify-center">
        {isExternalUrl(moreUrl) ? <a href={moreUrl} target="_blank" rel="noopener noreferrer" className="btn btn-link">
            {moreTitle}
          </a> : <Link to={`${moreUrl}`} className="btn btn-link">
            {moreTitle}
          </Link>}
      </div>
    </div>;
};
export { MiscEngage };